
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import StepList from "@/components/scope/step-list.vue";
import GeneralVehicleSelect from "@common/src/components/scope/vehicle-select/index.vue";
import dayjs from "dayjs";
import { plateCodeRuleEl, mobileRulesEl, mobileRules, mileageRulesEl } from "@common/src/utils/verify";
import { addCurrencyUnit } from "@common/src/utils/tools";
import NextMaintenanceDatePicker from "@common/src/components/scope/next-maintenance-datepicker/index.vue";
import NextMileageInput from "@common/src/components/scope/next-mileage-input/index.vue";
import t from "@common/src/i18n/t";
import _ from "lodash-es";

const service = namespace("service");
const user = namespace("user");
const staff = namespace("staff");
const customer = namespace("customer");
const app = namespace("app");
const setting = namespace("setting");

@Component({
  components: {
    StepList,
    GeneralVehicleSelect,
    NextMaintenanceDatePicker,
    NextMileageInput
  }
})
export default class ServiceView extends Vue {
  @service.Action getOrderDetail;
  @staff.Action getStaffList;
  @staff.Action getTechnicianStaffList;
  @service.Action setSupplementData;
  @service.Action orderArrival;
  @customer.Action getCustomerDetail;
  @service.Action updateOrder;
  @user.State userData;
  @setting.Getter isOpenDispatch;
  @customer.Action saveCustomer;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @app.State country;
  @user.State u8cStore;
  @service.Action preOrderCheckMileage;
  dayjs = dayjs;
  addCurrencyUnit = addCurrencyUnit;
  showPreviewPrint: boolean = false;
  get breadData() {
    return [
      { name: t("test.service-management"), path: "/service/index" },
      { name: t("service.additional-information") }
    ];
  }
  logData: any = [];
  advisorList: any = [];
  technicianStaffList: any = [];
  created() {
    this.init();
    console.log(this.$localMark);
  }
  get orderId() {
    return this.$route.params.id;
  }
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  detailData: any = { orderStatus: "9", photoList: [] };
  orderFormData: any = {
    advisorCode: "",
    leaveTime: dayjs().format("YYYYMMDD"),
    plateCode: "",
    customerModelCode: "",
    customerOilVolume: 0,
    customerCurrentMileage: "",
    customerNextMileage: "",
    customerNextMaintenanceDate: "",
    customerName: "",
    customerMobile: "",
    storeRemark: "" //门店备注
  };

  defaultVehicleList: any = [];
  async setSuppleMent() {
    // 根据是否选择现有用户来决定是新增用户还是更新用户
    // 老用户（订单带有用户code）直接用detailData.customerCode来更新，选择其他用户，就用this.customerCodeByPlateCode来更新用户信息
    let saveCustomerData: any = null;
    let createResult: any = null;
    if (!this.customerCodeByQuery) {
      saveCustomerData = {
        vehicle: {
          plateCode: this.orderFormData.plateCode,
          modelCode: this.orderFormData.customerModelCode,
          vehicleCode: this.orderFormData.vehicleCode || ""
        },
        customerCode: this.detailData.customerCode || "",
        customerName: this.orderFormData.customerName,
        mobile: this.orderFormData.customerMobile
      };
    } else {
      saveCustomerData = {
        vehicle: {
          plateCode: this.orderFormData.plateCode,
          modelCode: this.orderFormData.customerModelCode,
          vehicleCode: this.orderFormData.vehicleCode
        },
        customerCode: this.customerCodeByQuery,
        customerName: this.orderFormData.customerName,
        mobile: this.orderFormData.customerMobile
      };
    }

    let createHasError = false;
    this.btnStartLoading();
    createResult = await this.saveCustomer(saveCustomerData).catch(() => {
      this.btnStopLoading();
      createHasError = true;
    });

    // 如果创建用户出错，终止后续操作
    if (createHasError) return;
    this.setTechnicianArray();
    const params = Object.assign({}, this.orderFormData, {
      orderNo: this.orderId,
      customerCode: createResult
        ? createResult.data.customerCode
        : this.customerCodeByQuery || this.detailData.customerCode,
      customerMobile: createResult ? this.tmallMobile : this.orderFormData.customerMobile,
      vehicleCode: createResult ? createResult.data.vehicleCode : this.detailData.vehicleCode,
      serviceDetail: this.detailData.serviceDetail,
      partsDetail: this.detailData.partsDetail,
      // 处理油量
      customerOilVolume: this.orderFormData.customerOilVolume / 20
    });
    try {
      await this.beforeSaveOrder();
      this.setSupplementData(params)
        .then(() => {
          this.$message.success(`${t("service.order")}“${this.orderId}”${t("service.customer-arrived")}`);
          this.$router.push(`/service/view/${this.orderId}`);
        })
        .finally(() => {
          this.btnStopLoading();
        });
    } catch (e) {
      this.btnStopLoading();
    }
  }
  setTechnicianArray() {
    this.detailData.serviceDetail.forEach(serviceItem => {
      serviceItem.technicianArray = this.$safeValue(serviceItem, "technicianCode", []).map(item => ({
        technicianCode: item
      }));
    });
    this.detailData.partsDetail.forEach(parts => {
      parts.technicianArray = this.$safeValue(parts, "technicianCode", []).map(item => ({
        technicianCode: item
      }));
    });
  }
  // 控制form disable状态
  formDisableStatus = {
    customerModelCode: false,
    plateCode: false,
    customerName: false,
    customerMobile: false
  };
  get customerFormRules() {
    return {
      plateCode: [{ required: true, validator: this.validatePlateCode, trigger: "change" }],
      customerModelCode: [{ required: true, message: t("test.select-car-model"), trigger: "blur" }],
      customerMobile: [{ validator: this.validateMobile, trigger: "change" }],
      customerCurrentMileage: { required: this.u8cStore ? true : false, validator: this.checkMileage, trigger: "blur" },
      customerNextMileage: { validator: this.checkMileage, trigger: "blur" }
    };
  }
  checkMileage(rule, value, callback) {
    if (rule.field === "customerCurrentMileage") {
      mileageRulesEl(value, callback, !this.u8cStore);
    } else {
      mileageRulesEl(value, callback, true);
    }
  }
  validatePlateCode(rule, value, callback) {
    plateCodeRuleEl(value, callback, this.country);
  }
  mode: string = "1";
  get additionalList() {
    if (!this.detailData.additionalFees) {
      return [];
    }
    return [
      {
        additionalFees: this.detailData.additionalFees,
        additionalFeesRemark: this.detailData.additionalFeesRemark
      }
    ];
  }
  // 根据车牌或者手机号查询到的用户Code
  customerCodeByQuery: string = "";
  // 上次查询存在系统中的车牌号
  prevExistPlateCode: string = "";
  handleSelectedPlatecode(val, key) {
    let param;
    if (!val) {
      this.customerCodeByQuery = "";
      return;
    }
    if (key === "plateCode") {
      if (val.length < 2) {
        return;
      }
      param = { plateCode: val };
    } else {
      param = { mobile: val };
      if (!mobileRules(val).success) return false;
    }
    this.getCustomerDetail(param).then(data => {
      const customerData = data.data;
      if (customerData) {
        const vehicleData = data.data.vehicleList[0];
        this.customerCodeByQuery = customerData.customerCode;
        this.orderFormData.customerName = customerData.customerName;
        this.orderFormData.customerMobile = customerData.mobile;
        this.orderFormData.customerCurrentMileage = vehicleData.lastMaintenanceMileage;
        if (vehicleData) {
          this.orderFormData.vehicleCode = vehicleData.vehicleCode;
          if (vehicleData.plateCode) {
            this.prevExistPlateCode = vehicleData.plateCode;
            this.orderFormData.plateCode = vehicleData.plateCode;
          }
          this.defaultVehicleList = this.vehicleDataFormat([vehicleData]);
        }
      } else {
        if (key === "mobile") {
          this.customerCodeByQuery = "";
        } else {
          if (this.prevExistPlateCode) {
            this.$confirm(
              t("v270.please-confirm-the-modification") +
                this.prevExistPlateCode +
                t("v270.vehicles-or-new-ones") +
                val +
                t("v270.vehicle"),
              t("v210831.tips") as string,
              {
                confirmButtonText: t("v270.change") as string,
                cancelButtonText: t("v270.newly-added") as string,
                type: "warning",
                center: true
              }
            )
              .then(() => {
                // 变更不删除车辆code
              })
              .catch(() => {
                // 新增删除车辆code
                this.orderFormData.vehicleCode = "";
              });
          }
        }
      }
    });
  }
  vehicleDataFormat(data) {
    return data.map(item => ({
      lastValue: item.modelCode,
      name: item.brandName + " / " + item.seriesName + " / " + item.modelDesc,
      valueGroup: [item.brandCode, item.seriesName, item.modelCode]
    }));
  }
  validateMobile(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      mobileRulesEl(value, callback, this.country);
    }
  }
  tmallMobile: string = "";
  groupIndex: number = 1;
  async init() {
    await this.orderArrival({
      orderNo: this.orderId
    }).then(() => {});
    this.getTechnicianStaffList({
      // 获取角色为技师的员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.technicianStaffList = data.data.list;
    });
    this.getOrderDetail({
      orderNo: this.orderId
    }).then(data => {
      const serviceCodeMap = {}; // 存放映射关系
      data.data.partsDetail.forEach((parts, index) => {
        if (parts.serviceCode) {
          if (serviceCodeMap[parts.serviceCode]) {
            serviceCodeMap[parts.serviceCode].push(index);
          } else {
            serviceCodeMap[parts.serviceCode] = [index];
          }
        }
      });
      data.data.serviceDetail.forEach(serviceItem => {
        serviceItem.technicianCode = serviceItem.technicianArray
          ? serviceItem.technicianArray.map(item => item.technicianCode)
          : [];
        if (serviceCodeMap[serviceItem.serviceCode]) {
          serviceItem.isGroup = true;
          serviceItem.groupServiceIndex = this.groupIndex;
          serviceCodeMap[serviceItem.serviceCode].forEach(i => {
            data.data.partsDetail[i].isGroup = true;
            data.data.partsDetail[i].groupServiceIndex = this.groupIndex;
          });
          this.groupIndex++;
          // 格式化技师code
        }
      });
      this.detailData = data.data;
      console.log("[ data.data ]", data.data);
      // 设置车型默认
      this.defaultVehicleList = [
        {
          lastValue: data.data.customerModelCode,
          name: data.data.modelDesc
        }
      ];
      // 到店和小程序订单，根据值设置disable
      if (data.data.orderSource !== "2" && data.data.orderSource !== "6" && data.data.orderSource !== "4") {
        this.formDisableStatus.plateCode = true;
        this.formDisableStatus.customerModelCode = true;
        this.formDisableStatus.customerName = !!data.data.customerName;
      }
      // 设置客户姓名
      this.orderFormData.customerName = data.data.customerName;
      // 设置客户手机号
      this.orderFormData.customerMobile = data.data.customerMobile;
      // 设置车型code
      this.orderFormData.customerModelCode = data.data.customerModelCode;
      // 设置门店备注
      this.orderFormData.storeRemark = data.data.storeRemark || "";
      // 设置车牌号
      this.orderFormData.plateCode = data.data.plateCode || "";
      // vehicleCode
      this.orderFormData.vehicleCode = data.data.vehicleCode || "";
      // 如果是天猫订单，保存订单里面的手机号
      this.tmallMobile = this.orderFormData.customerMobile;
      // 设置下次保养时间和里程
      this.orderFormData.customerNextMileage = this.detailData.customerNextMileage || "";
      this.orderFormData.customerNextMaintenanceDate = this.detailData.customerNextMaintenanceDate || "";
      // 获取员工设置 顾问
      this.getStaffList({
        pageNum: 1,
        pageSize: 999
      }).then(data => {
        this.advisorList = data.data.list;
        this.orderFormData.advisorCode = this.userData.userCode;
        this.detailData.serviceDetail.forEach(item => {
          item.saleCode = this.userData.userCode;
        });
        this.detailData.partsDetail.forEach(item => {
          item.saleCode = this.userData.userCode;
        });
      });
    });
  }
  handleOpoColse() {
    // 车型选择关闭去掉错误状态
    (this.$refs["customerForm"] as any).validateField("customerModelCode");
  }
  submitForm() {
    (this.$refs["customerForm"] as any).validate(valid => {
      if (valid && this.checkDatavalid()) {
        if (this.detailData.processType === "TMALL") {
          // 天猫 乘用小程序
          this.setSuppleMent();
        } else {
          this.updateOrderInfo();
        }
      } else {
        console.log("error submit!!");
      }
    });
  }
  roderMapping: any = {
    "1": "maintenance",
    "2": "wash",
    "3": "retail"
  };
  get orderType() {
    return this.roderMapping[this.detailData.orderType] || "maintenance";
  }
  checkDatavalid(): boolean {
    for (let index = 0; index < this.detailData.serviceDetail.length; index++) {
      // 洗车项目 技师可以为空
      const element = this.detailData.serviceDetail[index];
      if (
        this.orderType !== "wash" &&
        !this.isOpenDispatch &&
        (!element.technicianCode || element.technicianCode.length < 1)
      ) {
        this.$message.error(t("service.select-service-technician"));
        return false;
      }
    }
    return true;
  }
  async updateOrderInfo() {
    this.btnStartLoading();
    this.setTechnicianArray();
    let params = Object.assign(this.detailData, {
      customerOilVolume: this.orderFormData.customerOilVolume / 20,
      customerCurrentMileage: this.orderFormData.customerCurrentMileage,
      customerNextMaintenanceDate: this.orderFormData.customerNextMaintenanceDate,
      customerNextMileage: this.orderFormData.customerNextMileage,
      customerName: this.orderFormData.customerName,
      arrivalStore: true,
      orderNo: this.orderId
    });
    const saveCustomerData = {
      vehicle: {
        plateCode: this.orderFormData.plateCode,
        modelCode: this.orderFormData.customerModelCode
      },
      customerCode: this.detailData.customerCode,
      customerName: this.orderFormData.customerName,
      mobile: this.orderFormData.customerMobile
    };
    try {
      await this.saveCustomer(saveCustomerData);
      await this.beforeSaveOrder();
      this.updateOrder(params)
        .then(() => {
          this.$message.success(t("service.arrived-store"));
          this.$router.push(`/service/view/${this.orderId}`);
        })
        .finally(() => {
          this.btnStopLoading();
        });
    } catch (e) {
      this.btnStopLoading();
    }
  }
  beforeSaveOrder() {
    const params = {
      ..._.pick(this.orderFormData, [
        "customerCurrentMileage",
        "customerNextMaintenanceDate",
        "customerNextMileage",
        "plateCode",
        "customerOilVolume",
        "vehicleCode"
      ]),
      orderNo: this.orderId
    };
    return this.preOrderCheckMileage(params).then(
      () => {
        return true;
      },
      res => {
        if (res.code === "speedbiz.system.vehicle-last-maintenance-mileage-error") {
          return this.$confirm(res.message, t("v210831.tips"), {
            confirmButtonText: t("v216_6.continue-saving"),
            cancelButtonText: t("base.cancel"),
            type: "warning"
          });
        } else {
          return true;
        }
      }
    );
  }
}
